module.exports = __webpack_public_path__ + "50bfe02716e253183f3dde9765b53b44.svg";